import { Stack, Typography } from "@mui/material";
import { Button } from "components/UI";
import { useFinanceSettingsStore } from "features/finances";
import { ChartOfAccountTable } from "../Tables";

export const ChartOfAccounts = () => {
  const openDefaultChartOfAccountsModal = useFinanceSettingsStore(
    state => state.openDefaultChartOfAccountsModal
  );

  return (
    <>
      <Stack direction="column" alignItems="center" spacing={2}>
        <Typography variant="h5" fontWeight={700}>
          Set Chart of account
        </Typography>
        <Typography variant="caption" textAlign="center">
          Set up your chart of accounts to categorize your income and expenses.
        </Typography>
        <Button onClick={openDefaultChartOfAccountsModal}>
          Generate default accounts
        </Button>
        <Typography variant="caption" textAlign="center" color="text.secondary">
          Note: You can add new accounts later in settings.
        </Typography>

        <Stack alignSelf="stretch">
          <ChartOfAccountTable onboarding />
        </Stack>
      </Stack>
    </>
  );
};
